import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BehaviorSubject } from 'rxjs';

import { BarActionButton } from '../../../../bar-action-button/bar-action-button';
import { BarActionButtonOptions } from '../../../../bar-action-button/bar-action-button-options.model';
import { BarActionButtonType } from '../../../../bar-action-button/bar-action-button-type.enum';
import { BarLayoutService } from '../../bar-layout.service';

@Component({
    selector: 'bar-layout-menu-operations',
    templateUrl: './bar-layout-menu-operations.component.html',
    host: { class: 'bar-layout-menu-operations' },
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BarActionButton, AsyncPipe]
})
export class BarLayoutMenuOperationsComponent implements OnInit {
    readonly #layout = inject(BarLayoutService);
    readonly #destroyRef = inject(DestroyRef);

    operations$ = new BehaviorSubject<BarActionButtonOptions[]>([]);

    ngOnInit() {
        this.#layout.operations$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((actions: BarActionButtonOptions[]) => {
            const transformActions = (actions) => {
                return actions.map((a) => {
                    a.type = BarActionButtonType.Default;
                    return a;
                });
            };
            if (actions) this.operations$.next(transformActions(actions));
            else this.operations$.next(actions);
        });
    }
}
